import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { createStudentAssessments, deletStudentAssessment, getStudentAssessment, updateStudentAssessment } from "actions/studentassessments";
import { isUserTeacher } from "helpers/user";
import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { Expandable } from "UI";
import { QuillEditor } from "UI/Inputs";
import { Button } from '@haldor/ui';
import MatrixAssessmentParagraph from "../Matrix/MatrixAssessment/MatrixAssessmentParagraph";

var StudentAssessmentFormV1 = /*#__PURE__*/function (_Component) {
  _inherits(StudentAssessmentFormV1, _Component);

  var _super = _createSuper(StudentAssessmentFormV1);

  function StudentAssessmentFormV1(props) {
    var _this;

    _classCallCheck(this, StudentAssessmentFormV1);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "createAssessments", function () {
      var assessments = [];
      var assessmentObj = {
        assessmentDetails: [],
        feedback: "",
        referenceId: _this.props.task.id,
        referenceType: "AssignmentTask",
        status: "",
        studentId: _this.props.task.assignedTo
      };
      assessments.push(assessmentObj);

      _this.setState({
        assessments: assessments
      });

      return;
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      var isTeacher = isUserTeacher(_this.props.currentUser);

      if (isTeacher == false) {
        return new Promise(function (resolve) {
          var assessments = _this.state.assessments;
          assessments.forEach(function (assessment) {
            assessment.feedback = _this.state.feedback;

            if (assessment.status != "ASSESSMENT_PUBLISHED") {
              assessment.status = values.status;
            }
          });

          if (_this.state.editMode) {
            _this.props.updateStudentAssessment(_this.props.assignment.id, assessments[0]).then(function () {
              if (_this.state.deleteAssessment.assessmentDetails.length > 0) {
                _this.props.deletStudentAssessment(_this.state.deleteAssessment, _this.props.assignment.id).then(function () {
                  resolve();

                  _this.props.onAbort(true, true);
                });
              } else {
                resolve();

                _this.props.onAbort(true, true);
              }
            });
          } else {
            _this.props.createStudentAssessments(_this.props.assignment.id, assessments[0]).then(function () {
              resolve();

              _this.props.onAbort(true, true);
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMatrixAssessmentUpdate", function (block, course) {
      var assessments = _this.state.assessments;
      var deleteAssessment = _this.state.deleteAssessment;
      assessments.forEach(function (assessment) {
        var find = assessment.assessmentDetails.findIndex(function (t) {
          return t.rowId == block.id;
        });

        if (find == -1) {
          var cellIndex = block.cells.map(function (cell) {
            return cell.selected;
          }).lastIndexOf(true);

          if (cellIndex > -1) {
            var blockObj = {
              cellId: block.cells[cellIndex].id,
              rowId: block.id,
              matrixId: course.matrixID
            };
            assessment.assessmentDetails.push(blockObj);

            if (_this.state.editMode) {
              var cellIndex = deleteAssessment.assessmentDetails.findIndex(function (t) {
                return t.rowId == block.id;
              });
              deleteAssessment.assessmentDetails.splice(cellIndex, 1);
            }
          }
        } else {
          var cellIndex = block.cells.map(function (cell) {
            return cell.selected;
          }).lastIndexOf(true);

          if (cellIndex == -1) {
            if (_this.state.editMode) {
              deleteAssessment.assessmentDetails.push(assessment.assessmentDetails[find]);
            }

            assessment.assessmentDetails.splice(find, 1);
          } else {
            var detail = assessment.assessmentDetails.find(function (t) {
              return t.rowId == block.id;
            });
            detail.cellId = block.cells[cellIndex].id;
          }
        }
      });

      _this.setState({
        assessments: assessments,
        deleteAssessment: deleteAssessment
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFeedbackChange", function (content) {
      _this.setState({
        feedback: content
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMatrix", function () {
      if (_this.props.assignment && _this.props.activeSection) {
        var associatedMatrices = _this.props.assignment.associatedMatrices;
        var courses = _this.props.activeSection.courses;

        if ((associatedMatrices === null || associatedMatrices === void 0 ? void 0 : associatedMatrices.length) > 0) {
          return courses.map(function (course) {
            var selectedRows = false;
            course.details.forEach(function (detail) {
              var matrix = associatedMatrices.find(function (matrix) {
                return matrix.courseId == course.id && detail.matrixID == matrix.matrixId;
              });

              if (matrix != null) {
                selectedRows = true;
              }
            });

            if (selectedRows) {
              return /*#__PURE__*/React.createElement("div", {
                key: course.id
              }, course.details.map(function (detail) {
                var matrix = associatedMatrices.find(function (matrix) {
                  return matrix.courseId == course.id && matrix.matrixId == detail.matrixID;
                });

                if (matrix != null) {
                  var title = course.title + " (" + detail.matrix.title;

                  if (detail.endDate != null) {
                    title += " (" + _this.props.translate("Expired") + "))";
                  } else {
                    title += ")";
                  }

                  return /*#__PURE__*/React.createElement(Expandable, {
                    title: title,
                    key: detail.id,
                    open: true,
                    color: course.colorCode,
                    ignorePropsUpdate: true
                  }, matrix._ParagraphSet.map(function (associatedParagraph) {
                    var paragraph = detail.matrix._ParagraphSet.find(function (p) {
                      return p.id == associatedParagraph.id;
                    });

                    if (paragraph != null) {
                      return /*#__PURE__*/React.createElement(MatrixAssessmentParagraph, {
                        key: paragraph.id,
                        assessments: _this.state.assessments,
                        items: [_this.props.task],
                        paragraph: paragraph,
                        associatedParagraph: associatedParagraph,
                        type: "multiple",
                        details: detail,
                        groupAssignment: _this.props.groupAssignment,
                        studentAssessment: true,
                        referenceType: _this.props.referenceType,
                        onMatrixAssessmentUpdate: _this.onMatrixAssessmentUpdate.bind(_assertThisInitialized(_this)),
                        disableNotAchieved: detail.matrix.disableNotAchieved
                      });
                    }
                  }));
                }
              }));
            }
          });
        }
      }

      return;
    });

    _this.state = {
      assessments: [],
      deleteAssessment: null,
      feedback: "",
      editMode: false
    };
    return _this;
  }

  _createClass(StudentAssessmentFormV1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.getStudentAssessment(this.props.assignment.id, this.props.task.assignedTo).then(function () {
        if (_this2.props.assessment) {
          var assessment = _this2.props.assessment;
          assessment.assessmentDetails = assessment.studentAssessmentDetails;

          if (assessment != null) {
            var assessments = [];
            assessments.push(assessment);
            var deleteAssessment = Object.assign({}, assessment);
            deleteAssessment.assessmentDetails = [];

            _this2.setState({
              editMode: true,
              assessments: assessments,
              feedback: assessment.feedback,
              deleteAssessment: deleteAssessment
            });
          }
        } else {
          _this2.createAssessments();
        }
      });
    }
  }, {
    key: "renderUserList",
    value: function renderUserList() {
      var _this3 = this;

      var isTeacher = isUserTeacher(this.props.currentUser);
      var studentAssessorTask = null;

      if (this.props.assignment != null && this.props.assignment.tasks != null && this.props.task != null && isTeacher) {
        studentAssessorTask = this.props.assignment.tasks.find(function (t) {
          return t.assignedTo == _this3.props.task.studentAssessorId;
        });
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
        className: "item-list"
      }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
        key: this.props.task.assignedTo
      }, /*#__PURE__*/React.createElement("td", {
        className: "name",
        style: {
          paddingLeft: "1.25em",
          fontWeight: "500"
        }
      }, this.props.task.groupName)), studentAssessorTask != null ? /*#__PURE__*/React.createElement("tr", {
        key: studentAssessorTask.assignedTo
      }, /*#__PURE__*/React.createElement("td", {
        className: "name",
        style: {
          paddingLeft: "1.25em",
          fontWeight: "500"
        }
      }, studentAssessorTask.groupName + " (" + this.props.translate("buddy-assessor") + ")")) : null)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          change = _this$props.change,
          pristine = _this$props.pristine,
          reset = _this$props.reset,
          submitting = _this$props.submitting,
          valid = _this$props.valid,
          assessments = _this$props.assessments;
      var isTeacher = isUserTeacher(this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container form-assessment"
      }, this.props.submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        className: "form form-component"
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate("students"),
        open: true
      }, this.renderUserList()), this.renderMatrix(), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(QuillEditor, {
        placeholder: this.props.translate("feedback"),
        label: this.props.translate("feedback"),
        onChange: this.onFeedbackChange,
        text: this.state.feedback
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this4.submit(_objectSpread(_objectSpread({}, values), {}, {
            status: "ASSESSMENT_PUBLISHED"
          }));
        }),
        disabled: submitting || !valid || isTeacher
      }, this.props.translate("save-assessment")), this.props.assignment.assessmentType == "BUDDY" ? /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this4.submit(_objectSpread(_objectSpread({}, values), {}, {
            status: "ASSESSMENT_STARTED"
          }));
        }),
        type: "secondary",
        disabled: submitting || !valid || isTeacher
      }, this.props.translate("save-draft")) : null, /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(event) {
          event.preventDefault();

          _this4.props.onAbort(false);
        }
      }, this.props.translate("Cancel"))))));
    }
  }]);

  return StudentAssessmentFormV1;
}(Component);

function mapStateToProps(state, ownProps) {
  var section = state.sections.activeSection;

  if (ownProps.section != null) {
    section = ownProps.section;
  }

  return {
    currentUser: state.user.currentUser,
    activeSection: section,
    assessment: state.assessments.studentAssessment,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  createStudentAssessments: createStudentAssessments,
  updateStudentAssessment: updateStudentAssessment,
  getStudentAssessment: getStudentAssessment,
  deletStudentAssessment: deletStudentAssessment
})(reduxForm({
  form: "StudentAssessmentForm",
  destroyOnUnmount: true
}, mapStateToProps)(StudentAssessmentFormV1));